export default "__VITE_ASSET__bdda7c13__"